export default __webpack_public_path__ + "static/media/page.205b22c0.png";